// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { popularCategoriesStyles } from "@pace/App/Widgets/PopularCategories/PopularCategories";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, getSystemColor } from "@pace/XDL/Utilities";
import { css } from "styled-components";

popularCategoriesStyles.categoryTitleLink = {
    size: 14,
    weight: fontConfig.weight.bold,
    css: css`
        line-height: 22px;
        &&& {
            color: ${getSystemColor("common.ui6")};
            text-align: center;
        }
        padding: 8px;
        justify-content: center;
    `,
};

popularCategoriesStyles.categoryCardClickableWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        &:hover {
            border-color: ${color("primary")};
        }
        width: 204px;
        height: 204px;
    `,
};

popularCategoriesStyles.imageWrapper = {
    css: css`
        width: 100%;
        height: 144px;
    `,
};

popularCategoriesStyles.sectionWrapperStyles = {
    wrapper: {
        css: css`
            & > div {
                height: 100%;
            }
        `,
    },
};
popularCategoriesStyles.categoryCarousel = {
    container: {
        css: css`
            .swiper-slide {
                width: unset !important;
            }
        `,
    },
};
popularCategoriesStyles.image = {
    width: "204px",
    css: css`
        width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 4px 4px 0 0;
        img {
            height: 100%;
            object-fit: contain;
        }
    `,
};

popularCategoriesStyles.categoryCardsContainer = {
    css: css`
        padding-top: 0;
        gap: 0 22px;
        height: 100%;
        display: flex;
        flex-wrap: nowrap;
    `,
};
